<template>
  <div class="page_wrapper">
    <p></p>
    <div class="box">
      <h3>Edit your RSVP. </h3>
      <p>We hope this helps you navigate the <router-link to="/mines">minefield</router-link> of life.</p>
    </div>
  </div>
</template>

<script>
export default {
};
</script>

<style scoped>
</style>
